import { createAction } from "@reduxjs/toolkit"
import type { VisitListSerializer } from "@/types/visit"
import type { ReservationExtendSerializer } from "@/types/reservation"

export const applyPatientListUpdates = createAction<{
  date: string
  visits?: Partial<Record<"waiting" | "treatment" | "complete", VisitListSerializer[]>>
  reservations?: ReservationExtendSerializer[]
}>("patientLists/apply")
